import { BirdFlying } from "./BirdFlying";

export function Lvl2(props) {
  return <BirdFlying />;
}
